import { render } from "./SendCodetoPhone.vue?vue&type=template&id=95ccb428&scoped=true"
import script from "./SendCodetoPhone.vue?vue&type=script&lang=js"
export * from "./SendCodetoPhone.vue?vue&type=script&lang=js"

import "./SendCodetoPhone.vue?vue&type=style&index=0&id=95ccb428&scoped=true&lang=css"
import "./SendCodetoPhone.vue?vue&type=style&index=1&id=95ccb428&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95ccb428"]])

export default __exports__